import { useSelector } from "react-redux";
import MeasurementARStatusModal from "../Measurement/MeasurementARStatusModal";
import arMarkupService from "../../services/MarkupService/arMarkupService";

const ARMarkupStatusPopup = () => {
    const { arMarkupStatusPopup } = useSelector((state) => state.markup);
    return (
        <>
            {arMarkupStatusPopup === arMarkupService.popupStatus.notSupportAR && (
                <MeasurementARStatusModal
                    actionType={arMarkupService.popupStatus.notSupportAR}
                    modalTitleKey={"device_not_compatible_for_AR_Markup"}
                    modalBodyKey={"device_not_support_google_play_service_for_markup"}
                    isARNotSupportedLink
                    handleCloseModal={() => arMarkupService.showARMarkupStatusPopup(arMarkupService.popupStatus.unset)}
                />
            )}
            {arMarkupStatusPopup === arMarkupService.popupStatus.appNotInstalled && (
                <MeasurementARStatusModal
                    actionType={arMarkupService.popupStatus.appNotInstalled}
                    modalTitleKey={"app_required_for_AR_Markup"}
                    modalBodyKey={"device_required_google_play_service_for_markup"}
                    handleCloseModal={() => arMarkupService.showARMarkupStatusPopup(arMarkupService.popupStatus.unset)}
                />
            )}
            {arMarkupStatusPopup === arMarkupService.popupStatus.needsToUpdateApp && (
                <MeasurementARStatusModal
                    actionType={arMarkupService.popupStatus.needsToUpdateApp}
                    modalTitleKey={"app_required_update_for_AR_Markup"}
                    modalBodyKey={"device_required_update_google_play_service_for_markup"}
                    handleCloseModal={() => arMarkupService.showARMarkupStatusPopup(arMarkupService.popupStatus.unset)}
                />
            )}
        </>
    );
};

export default ARMarkupStatusPopup;
